import { touchSession } from '@/api/session';

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
const ACTIVITY_EVENTS: (keyof WindowEventMap)[] = ['mousemove', 'keydown', 'click', 'scroll'];

export const useSessionHeartbeat = () => {
    let intervalId: ReturnType<typeof setInterval> | null = null;
    let userIsActive = false;

    const onActivity = () => {
        userIsActive = true;
    };

    const tick = async () => {
        if (!userIsActive) return;
        userIsActive = false;

        try {
            await touchSession();
        } catch {
            // Silently ignore — session touch is best-effort
        }
    };

    const start = () => {
        if (intervalId !== null) return;

        userIsActive = true; // Count login itself as activity
        ACTIVITY_EVENTS.forEach((event) => window.addEventListener(event, onActivity, { passive: true }));
        tick(); // Immediate touch so short visits are registered
        intervalId = setInterval(tick, HEARTBEAT_INTERVAL_MS);
    };

    const stop = () => {
        if (intervalId !== null) {
            clearInterval(intervalId);
            intervalId = null;
        }
        ACTIVITY_EVENTS.forEach((event) => window.removeEventListener(event, onActivity));
        userIsActive = false;
    };

    return { start, stop };
};
